var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification_New",
    "data-name": "Notification/New",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Status_New_Background_Mask_",
    "data-name": "Status/New (Background/Mask)",
    width: 12,
    height: 12,
    rx: 6,
    fill: "#45b26b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status_New",
    "data-name": "Status/New",
    transform: "translate(17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Status_New_Background_Mask_2",
    "data-name": "Status/New (Background/Mask)",
    width: 12,
    height: 12,
    rx: 6,
    fill: "#45b26b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Burger_Line",
    "data-name": "icons/Burger/Line",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9,19a2.258,2.258,0,0,1-1.591-.647l-.073-.174a1,1,0,0,1,.922-1.389H9.743a1,1,0,0,1,.922,1.389l-.073.174A2.258,2.258,0,0,1,9,19Zm8.116-3.093H.884a.883.883,0,1,1,0-1.767H.9V7.981A8.05,8.05,0,0,1,9,0a8.05,8.05,0,0,1,8.1,7.981V14.14h.016a.883.883,0,1,1,0,1.767ZM9,1.768A6.264,6.264,0,0,0,2.7,7.981V14.14H15.3V7.981A6.264,6.264,0,0,0,9,1.768Z",
    transform: "translate(0 0)",
    fill: "#777e90"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActive);
export default __webpack_public_path__ + "static/media/NotificationsActive.bdfce98fe4208b762f622f4ae7161179.svg";
export { ForwardRef as ReactComponent };